// extracted by mini-css-extract-plugin
export default {"logo":"LoginView_logo__9Pcbj","resendCodeLink":"LoginView_resendCodeLink__gThua"};